import { Component } from "react";
// import { withRouter } from "react-router-dom";

class WarningAlert extends Component {
  render() {
    return (
      <div class="alert  alert-warning alert-dismissible">
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-hidden="true"
        >
          &times;
        </button>
        <h4>
          <i class="icon fa fa-exclamation-triangle"></i>
          {this.props.message}
        </h4>
      </div>
      // </div></div></section></div>
    );
  }
}
export default WarningAlert;
